

export function getLeaderboardFooterSetting(event) {
    let dashboardSetting = event?.leaderboard_dashboard_setting || {};

    let footerSetting = dashboardSetting?.footer || "";

    // console.log("getLeaderboardFooterSetting: footerSetting=", footerSetting)

    if(footerSetting == ""){
        //
        // console.log("getLeaderboardFooterSetting: empty footer setting, use default")
        return {
            footerLeft: "hsta",
            footerRight: "bfcf",
            footerCenter: "sponsor1"
        };
    }

    let setting = {
        footerLeft: footerSetting?.left || "",
        footerRight: footerSetting?.right || "",
        footerCenter: footerSetting?.center || "",
    }

    return setting;
}



